import bem from 'utils/bem';

export const block = bem('doc-limitations-alert-modal');
